export default __webpack_public_path__ + "static/C04-de48f6dfb26f792ff0de8560e2615dd5.jpg";